import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';

import HelpGuide from 'help/components/guide';
import { fetchGuideIfNeeded, voteGuide } from 'help/ducks/guides';

HelpGuide.need = [
  params => fetchGuideIfNeeded(params.guideSlug)
];

export function mapStateToProps({ help: { guides } }) {
  return {
    ...guides
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const { guideSlug } = params;
  const actions = {
    fetchGuideIfNeeded: partial(fetchGuideIfNeeded, guideSlug),
    upvote: partial(voteGuide, guideSlug, true),
    downvote: partial(voteGuide, guideSlug, false),
  };

  return bindActionCreators(actions, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HelpGuide));



// WEBPACK FOOTER //
// ./help/containers/guide.js